import { render, staticRenderFns } from "./UploadImgNew.vue?vue&type=template&id=163f30c1&scoped=true&"
import script from "./UploadImgNew.vue?vue&type=script&lang=js&"
export * from "./UploadImgNew.vue?vue&type=script&lang=js&"
import style0 from "./UploadImgNew.vue?vue&type=style&index=0&id=163f30c1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163f30c1",
  null
  
)

export default component.exports